export default "__VITE_PUBLIC_ASSET__78107457__"